import React, { Fragment, useEffect, useState } from "react";
import toast from "react-hot-toast";
import DataTable from "../../../Common/Components/DataTable";
import { GetData } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
function List() {
  const initialState = {
    loading: false,
    data: {
      data: null,
    },
    modal: false,
  };
  const navigate = useNavigate();
  const [filter, setfilter] = useState({});
  const [state, setstate] = useState(initialState);
  useEffect(() => {
    Handler();
  }, []);

  const Handler = (pageNumber = 1, id, limit, index) => {
    setstate({ ...state, loading: true });
    GetData(pageNumber, id, limit, index, filter).then(result => {
      if (result) {
        setstate({
          ...state,
          loading: false,
          data: result[0],
        });
      }
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | لیست مناطق</title>
      </Helmet>

      <DataTable
        loading={state.loading}
        filter={true}
        heads={[
          {
            title: "نام کاربر",
            key: "fullname",
          },
          {
            title: "نام کاربر",
            key: "mobile",
          },
          {
            title: "موضوع",
            key: "title",
          },
          {
            title: "نوع دستگاه",
            key: "platform",
          },
          {
            title: "اخرین بروز رسانی",
            key: "updated_at",
            type: "date",
            timetype: "date-time",
          },
        ]}
        textEmpty="گزارشی ثبت نشده است"
        list={state.data && state.data.data}
        data={state.data}
        function={Handler}
        currentPage={state.data && state.data.current_page}
        header=" لیست گزارشات"
        links={[
          {
            typeLink: "sort",
            size: "col-md-12",
            html: (
              <div className="row">
                <div className="col-md-6">
                  <select
                    onChange={e => {
                      setfilter({ ...filter, platform: e.target.value });
                    }}
                    className="form-control "
                  >
                    <option value={""}>همه پلتفرم ها</option>
                    <option value={"android"}>android</option>
                    <option value={"ios"}>ios</option>
                    <option value={"site"}>وبسایت</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <select
                    onChange={e => {
                      setfilter({ ...filter, status: e.target.value });
                    }}
                    className="form-control "
                  >
                    <option value={""}>همه</option>
                    <option value={"asccepted"}>تایید شده</option>
                    <option value={"rejected"}>تایید نشده</option>
                    <option value={"waiting"}>در انتظار تایید</option>
                  </select>
                </div>
              </div>
            ),
          },

          {
            function: selected => {
              state.data.data.map((report, key) => {
                if (report.id === selected[0]) {
                  navigate("/Admin/Report/Single", {
                    state: {
                      id: selected[0],
                    },
                  });
                }
              });
            },
            color: "danger",
            size: "col-md-3",
            html: "مشاهده",
            type: "show",
            main: true,
          },
        ]}
      />
    </Fragment>
  );
}

export default List;
